export default {
	"Banner.ShopBanner": "店铺banner",
	"Banner.MarketingMallComponentClick": "营销商城_组件点击",
	"Banner.MarketingMarketplace": "营销商城"
}